import HistoryRoute from './history.jsx'

export default HistoryRoute;